import React from 'react'
import {  Redirect, Route, Switch } from 'react-router-dom'
import { CiudadesPage } from '../components/dashboard/ciudades/CiudadesPage'
import { DetalleImpuestoPage } from '../components/dashboard/detalleimpuestos/DetalleImpuestoPage'
import { HomePage } from '../components/dashboard/home/HomePage'
import { MembresiaPage } from '../components/dashboard/membresias/MembresiaPage'
import { NameImpuestoPage } from '../components/dashboard/nameimpuestos/NameImpuestoPage'
import { UsuarioPage } from '../components/dashboard/users/UsuarioPage'
import { Footer } from '../components/structure/Footer'

import { Navbar } from '../components/structure/Navbar'
import { Sidebar } from '../components/structure/Sidebar'
import { EditarImpuestoPage } from '../components/dashboard/editar-impuestos/EditarImpuestoPage'
import { CompraMembresiasPage } from '../components/dashboard/compra-membresias/CompraMembresiasPage'
import { TipoMembresiasPage } from '../components/dashboard/tipo-membresias/TipoMembresiasPage'
import { ContadoresPage } from '../components/dashboard/contadores/ContadoresPage'
import { ClientesPage } from '../components/dashboard/clientes/ClientesPage'
import { AuxiliaresPage } from '../components/dashboard/auxiliares/AuxiliaresPage'

export const DashboardRouter = () => {
    return (
        <div>
            <Navbar />
            <Sidebar />
            <Switch>
                <Route exact path="/dashboard/home" component={HomePage} />
                <Route exact path="/dashboard/usuario" component={UsuarioPage} />
                <Route exact path="/dashboard/ciudades" component={CiudadesPage} />
                <Route exact path="/dashboard/detalleimpuesto" component={DetalleImpuestoPage} />
                <Route exact path="/dashboard/nombreimpuesto" component={NameImpuestoPage} />
                <Route exact path="/dashboard/membresias" component={MembresiaPage} />
                <Route exact path="/dashboard/editarimpuestos" component={EditarImpuestoPage} />
                <Route exact path="/dashboard/compraMembresias" component={CompraMembresiasPage} />
                <Route exact path="/dashboard/tipoMembresias" component={TipoMembresiasPage} />
                <Route exact path="/dashboard/contadores" component={ContadoresPage} />
                <Route exact path="/dashboard/clientes" component={ClientesPage} />
                <Route exact path="/dashboard/clientes/:id_contador" component={ClientesPage} />
                <Route exact path="/dashboard/auxiliares" component={AuxiliaresPage} />
                <Route exact path="/dashboard/auxiliares/:id_contador" component={AuxiliaresPage} />
                <Redirect to="/auth/login" />

            </Switch>
            <Footer/>

        </div>
    )
}
